import { render, staticRenderFns } from "./paiweidengji.vue?vue&type=template&id=cacd02ea&scoped=true"
import script from "./paiweidengji.vue?vue&type=script&lang=js"
export * from "./paiweidengji.vue?vue&type=script&lang=js"
import style0 from "./paiweidengji.vue?vue&type=style&index=0&id=cacd02ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacd02ea",
  null
  
)

export default component.exports